import { TextFieldEntry as TFE } from '@bpmn-io/properties-panel';
import type { FunctionalComponent, VNode } from '@bpmn-io/properties-panel/preact';
import type { Element } from 'bpmn-js/lib/model/Types';

export const TextFieldEntry = TFE as <E extends Element = Element>(props: {
    debounce: <T extends (...args: unknown[]) => unknown>(fn: T) => T;
    description?: string;
    disabled?: boolean;
    element: E;
    getValue: (element: E) => string;
    id: string;
    label?: string;
    onBlur?: (event: FocusEvent) => void;
    onFocus?: (event: FocusEvent) => void;
    placeholder?: string;
    setValue: (value: string, validationError?: unknown) => void;
    tooltip?: string | FunctionalComponent;
    validate?: (value: string) => string | undefined | void;
}) => VNode;
